import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=a8653ca4&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=a8653ca4&prod&scoped=true&lang=css"
import style1 from "./EditForm.vue?vue&type=style&index=1&id=a8653ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8653ca4",
  null
  
)

export default component.exports